import { render } from "./CollaboratorEdit.vue?vue&type=template&id=43cb9c55&scoped=true"
import script from "./CollaboratorEdit.vue?vue&type=script&lang=js"
export * from "./CollaboratorEdit.vue?vue&type=script&lang=js"

import "./CollaboratorEdit.vue?vue&type=style&index=0&id=43cb9c55&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cb9c55"]])

export default __exports__